import { useContext, useEffect, useRef } from 'react';
import { MainContext } from '../context/main.context';
import { deleteUserAuthDataId, getUserAuthData, getUserAuthDataId } from '../common/tools';
import { toast } from 'react-toastify';
import { checkUserAuthState, setUserAuthState } from '../stores/auth.store';
import ManualController from './ManualController';


export default function AuthState() {
    const { toggleLoader } = useContext(MainContext);
    const { manualRedirect } = ManualController();
    const popupRef = useRef<any>(null);
    const closeWindowIntervalRef = useRef<any>(null);
    const checkAuthIntervalRef = useRef<any>(null);

    useEffect(() => {
        return () => {
            _cancel();
        };
    }, []);

    const startCheckUserAuthState = (url: string) => {
        const userAuthDataId: string | null = getUserAuthDataId();

        if (!userAuthDataId) {
            toast.error('SET_USER_AUTH_STATE_ID_NOT_FOUND');
            return;
        }

        _setUserAuthState(url, userAuthDataId);
    }

    const _setUserAuthState = (url: string, userAuthDataId: string) => {
        toggleLoader(true);

        setUserAuthState(userAuthDataId).then(res => {
            const result = res?.data?.result;

            if (result) {
                checkAuthIntervalRef.current = setInterval(() => {
                    _checkUserAuthState(userAuthDataId);
                }, 2000);

                popupRef.current = window.open(url, '_blank');
                return;
            }

            toast.error('CHECK_USER_AUTH_STATE_ERROR');
        }, err => {
            const errData = err?.response?.data || err;

            console.error('SET_USER_AUTH_STATE_ERROR', { errData });
            toast.error('SET_USER_AUTH_STATE_ERROR');

            toggleLoader(false);
        });
    }

    const _checkUserAuthState = (userAuthDataId: string) => {
        checkUserAuthState(userAuthDataId).then(res => {
            const result = res?.data?.authData?.result;

            if (result) {
                _cancel();
                manualRedirect(result, 'auth');
                return;
            }

            if (popupRef?.current?.closed) {
                _cancel();
            }
        }, err => {
            const errData = err?.response?.data || err;

            console.error('CHECK_USER_AUTH_STATE_ERROR', { errData });
            toast.error('CHECK_USER_AUTH_STATE_ERROR');

            toggleLoader(false);
        });
    }

    const checkUserAuth = (authType: 'redirect' | 'postMessage' | 'browser' | '') => {
        if (getUserAuthData()) {
            return;
        }

        const userAuthDataId: string | null = getUserAuthDataId();

        if (!userAuthDataId) {
            return;
        }

        toggleLoader(true);

        checkUserAuthState(userAuthDataId).then(res => {
            const result = res?.data?.authData?.result;

            if (result) {
                console.log({authType});
                manualRedirect(result, 'auth', false, 0, authType);
            }

            deleteUserAuthDataId();
        }, err => {
            const errData = err?.response?.data || err;

            console.error('CHECK_USER_AUTH_STATE_ERROR', { errData });
            toast.error('CHECK_USER_AUTH_STATE_ERROR');

            toggleLoader(false);
        });
    }

    const _cancel = () => {
        clearInterval(checkAuthIntervalRef.current);
        clearInterval(closeWindowIntervalRef.current);
        toggleLoader(false);
    }

    return {
        startCheckUserAuthState,
        checkUserAuth,
    }
}